import React, { Component } from "react";
import { Link } from 'react-router-dom'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'

//make sure to implement payments via stripe on this page


// const Styles = styled.div`
//   .button {
//     background-color: #000;
//     margin: 3px
//     border-color: #000
//   }

//   .card {
//     align-items: center
//   }
// `;

export default class SpecificEvent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allData: this.props.location.state.allData,         //contains ALL data about the event from Events.js page
        };
    }

    // componentDidMount() {
    // };

    render() {
        return (
            <Container style={{ justifyContent:'center', alignItems:'center', justifyItems:'center' }}>
                    <Card className="card" >
                        <Card.Img style={{  }} variant="top" src={this.state.allData.eventFlyer} />
                        <Row style={{ justifyContent: 'center' }}>
                            <h1>{this.state.allData.eventName}</h1>
                            <h4>{this.state.allData.eventDescription}</h4>
                            <h4>Price: ${this.state.allData.eventPrice}</h4>
                        </Row>
                    </Card>

            </Container>
        )
    }
}


